import useUserStore from "@/store/userStore";
import config from "@/config/config";
import { redirect } from "@tanstack/react-router";

export const IsAuthenticated = async () => {
  const { token } = useUserStore.getState();
  if (!token) {
    throw redirect({
      to: "/",
    });
  }
};

export const getLoginURL = (
  redirect: string,
  base: string = window.location.href,
  register?: boolean,
) => {
  if (base.includes("gratitude")) {
    base = base.split("gratitude")[0];
  }

  if (base.includes("circleId")) {
    /**
     * base64 encode the base url if it contains circleId.
     * The purpose here is to preserve query parameters sent along with the base url.
     *
     * The case here that when sharing a circle link, it is needed to track the user who shared the link.
     * The approach here is to add userId as a query parameter to the base url, then encode it to base64 url.
     * The purpose of the encoding here is to prevent the server side from truncating query parameters which happens to be done by both the Django and keycloak server.
     *
     * URL example: http://localhost:5173/?circleId=236ce80e-91af-49ca-bc4f-f865e77dd84d&userId=b0c1588a-829f-404d-bd81-36dab2127aeb
     * Encoded URL example: aHR0cDovL2xvY2FsaG9zdDo1MTczLz9jaXJjbGVJZD0yMzZjZTgwZS05MWFmLTQ5Y2EtYmM0Zi1mODY1ZTc3ZGQ4NGQmdXNlcklkPWIwYzE1ODhhLTgyOWYtNDA0ZC1iZDgxLTM2ZGFiMjEyN2FlYg==
     *
     * */
    base = btoa(base);
  }

  return (
    config.baseURL + "/auth/login" + `?to=${base}/${redirect}` + (register ? "&register=true" : "")
  );
};

export const getLogoutURL = (
  redirect?: string,
  base: string = window.location.href,
) => {
  let url = config.baseURL + "/auth/logout_v2";
  if (redirect) {
    url += `?redirect_to=${base}/${redirect}`;
  }
  return url;
};